import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { FormCard, Toast } from './theme';
import API_BASE_URL from '../config/api';

const CreateArticleSection = () => {
  const { role } = useAuth();
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [form, setForm] = useState({ title: '', content: '', visibility: 'PUBLIC' });
  const [submitting, setSubmitting] = useState(false);

  const userFullName = `${localStorage.getItem('vrvName') || ''} ${localStorage.getItem('vrvSurname') || ''}`.trim();
  const userEmail = localStorage.getItem('vrvEmail') || '';
  const roles = (role || '').split(',').map(s => s.trim().toUpperCase());
  const isAdmin = roles.includes('ADMIN');
  const canDirectPublish = isAdmin || (roles.includes('CONTENT-CREATOR') && roles.includes('CONTENT-APPROVER'));

  const showMsg = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: '' }), 3500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.content) { showMsg('Please fill all required fields', 'error'); return; }
    setSubmitting(true);
    try {
      const token = localStorage.getItem('vrvToken');
      const res = await fetch(`${API_BASE_URL}/vrv-articlecontent-create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          ...form,
          createdBy: userEmail,
          createdAt: new Date().toISOString(),
          status: canDirectPublish ? 'APPROVED' : 'PENDING',
          visibility: canDirectPublish ? form.visibility : 'PRIVATE',
          ...(canDirectPublish && { reviewedBy: userEmail, reviewerFullName: userFullName || userEmail, reviewedAt: new Date().toISOString(), reviewComments: 'Auto-approved on publish' }),
        }),
      });
      const data = await res.json();
      if (res.ok) { showMsg('Article created successfully!', 'success'); setForm({ title: '', content: '', visibility: 'PUBLIC' }); }
      else showMsg(data.message || data.error || 'Failed to create article', 'error');
    } catch { showMsg('Error connecting to server', 'error'); }
    setSubmitting(false);
  };

  return (
    <div>
      <FormCard title="Create New Article" subtitle="Article Content">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="vrv-label">Title *</label>
            <input type="text" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}
              placeholder="Article title" className="vrv-input" required />
          </div>
          <div>
            <label className="vrv-label">Content *</label>
            <textarea value={form.content} onChange={e => setForm({ ...form, content: e.target.value })}
              placeholder="Write your article content here…" rows="8"
              className="vrv-input resize-none" required />
          </div>
          <div className="flex flex-wrap gap-4 items-end">
            {canDirectPublish && (
              <div>
                <label className="vrv-label">Visibility</label>
                <select value={form.visibility} onChange={e => setForm({ ...form, visibility: e.target.value })} className="vrv-select" style={{ width: 'auto', minWidth: '140px' }}>
                  <option value="PUBLIC">🌐 Public</option>
                  <option value="PRIVATE">🔒 Private</option>
                </select>
              </div>
            )}
            <button type="submit" disabled={submitting} className="btn-gold">
              {submitting ? 'Submitting…' : canDirectPublish ? 'Publish Article →' : 'Send for Approval →'}
            </button>
          </div>
        </form>
      </FormCard>
      <Toast toast={toast} onClose={() => setToast({ show: false, message: '', type: '' })} />
    </div>
  );
};

export default CreateArticleSection;
